
















import { DynamicDocumentItem, DynamicDocumentItemData, InstallationModuleData } from "@/types";
import Vue, { PropType } from "vue";

import ItemHeader from "./ExpandableItemHeader.vue";

export default Vue.extend({
  components: {
    ItemHeader
  },

  props: {
    item: {
      type: Object as PropType<DynamicDocumentItem>
    },

    data: {
      type: Array as PropType<DynamicDocumentItemData[]>,
      default: () => []
    },
    moduleData: Object as PropType<InstallationModuleData>
  },

  computed: {
    itemData(): DynamicDocumentItemData {
      return this.data.find(data => data.field === this.item.field)!;
    }
  }
});
